module.exports = __webpack_public_path__ + "static/img/detail-signupbg.167e5cf7.png";